export default __webpack_public_path__ + "static/media/ЗГ-107 Цалингийн доод тогтоол.2f077b99.pdf";